import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Main footer content */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="/logo/logo_landscape.svg"
              alt="Plejesøstrene ApS"
              className="h-10 w-auto brightness-0 invert opacity-90"
            />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Specialiseret vikarbureau til den kommunale plejesektor –
              plejehjem, hjemmepleje, bosteder og plejecentre.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
              Navigation
            </h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "/for-vikarer", label: "For vikarer" },
                { href: "/for-institutioner", label: "For institutioner" },
                { href: "/om-os", label: "Om os" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/kontakt"
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
              Juridisk
            </h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "/privatlivspolitik", label: "Privatlivspolitik" },
                { href: "/cookiepolitik", label: "Cookiepolitik" },
                { href: "/servicevilkar", label: "Servicevilkår" },
                { href: "/tilgaengelighed", label: "Tilgængelighed" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
              Kontakt
            </h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-2.5 text-sm">
                <MapPin size={15} className="text-brand-400 mt-0.5 shrink-0" />
                <span>
                  Helgavej 26
                  <br />
                  5230 Odense M
                </span>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <Phone size={15} className="text-brand-400 shrink-0" />
                <a
                  href="tel:+4589801515"
                  className="hover:text-white transition-colors"
                >
                  89 80 15 15
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <Mail size={15} className="text-brand-400 shrink-0" />
                <a
                  href="mailto:info@plejesoestrene.dk"
                  className="hover:text-white transition-colors"
                >
                  info@plejesoestrene.dk
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            &copy; {currentYear} Plejesøstrene ApS &middot; CVR 45991768
          </p>
          <button
            onClick={() =>
              window.showCookieSettings && window.showCookieSettings()
            }
            className="text-xs text-slate-500 hover:text-slate-300 transition-colors cursor-pointer"
          >
            Cookie-indstillinger
          </button>
        </div>
      </div>
    </footer>
  );
}
